import styled from 'styled-components';
import { SecondaryButton, color } from '../App.styles';
import { PLACEHOLDER_LABELS } from '../minutes';

function GuideModal({ onClose }) {
  return (
    <Backdrop onClick={onClose}>
      <Dialog role="dialog" aria-modal="true" aria-labelledby="guide-title" onClick={(e) => e.stopPropagation()}>
        <h2 id="guide-title">이용 가이드</h2>
        <ol>
          <li>
            <b>템플릿</b>을 고릅니다. 양식이 없으면 기본 템플릿을 쓰고, 회사 양식이 있으면 .docx 파일을 올립니다.
          </li>
          <li>
            <b>회의 정보</b>는 아는 것만 적습니다. 비워 둔 항목은 회의 기록에서 찾아 채우고, 찾지 못하면 "-"로 둡니다.
          </li>
          <li>
            <b>회의 기록</b>을 붙여넣거나 .txt, .docx 파일로 올린 뒤 "AI로 회의록 정리하기"를 누릅니다.
          </li>
          <li>결과를 확인하고 복사하거나 Word 파일로 내려받습니다.</li>
        </ol>

        <h3>내 템플릿 사용하기</h3>
        <p>
          쓰고 있는 Word 양식(.docx)을 그대로 올리면 AI가 양식을 분석해 항목별로 채울 자리를 찾습니다. 회의 정보
          입력란도 양식에 있는 항목(부서, 회의 번호 등)으로 바뀝니다. 글꼴과 표 등 양식은 그대로 유지됩니다.
        </p>
        <p>
          자리를 정확히 지정하고 싶다면 양식의 해당 위치에 항목 이름을 $로 감싸 적어 주세요(예: $부서$). $ 표시가
          있으면 분석 없이 표시한 자리에 채웁니다. 회의 내용과 액션아이템은 아래 이름을 그대로 써 주세요.
        </p>
        <Chips>
          {PLACEHOLDER_LABELS.map((label) => (
            <code key={label}>${label}$</code>
          ))}
        </Chips>

        <p className="notice">입력한 내용은 저장되지 않습니다. 정리에 필요한 동안만 처리하고 바로 버립니다.</p>

        <SecondaryButton onClick={onClose}>닫기</SecondaryButton>
      </Dialog>
    </Backdrop>
  );
}

const Backdrop = styled.div`
  position: fixed;
  inset: 0;
  z-index: 10;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 16px;
  background-color: rgba(27, 38, 48, 0.4);
`;

const Dialog = styled.div`
  width: 100%;
  max-width: 560px;
  max-height: calc(100vh - 32px);
  overflow-y: auto;
  padding: 28px;
  background-color: #fff;
  border-radius: 14px;
  font-size: 14px;
  line-height: 1.7;
  color: ${color.textSub};

  h2 {
    margin-bottom: 12px;
    font-size: 20px;
    color: ${color.text};
  }

  h3 {
    margin: 20px 0 6px;
    font-size: 15px;
    color: ${color.text};
  }

  ol {
    padding-left: 18px;
  }

  ol li {
    list-style: decimal;
  }

  .notice {
    margin: 20px 0;
    font-size: 13px;
    color: ${color.textMuted};
  }
`;

const Chips = styled.div`
  display: flex;
  flex-wrap: wrap;
  gap: 6px;
  margin-top: 10px;

  code {
    padding: 2px 8px;
    background-color: ${color.primaryLight};
    border-radius: 6px;
    font-size: 13px;
    color: ${color.primaryHover};
  }
`;

export default GuideModal;
